__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/79291ff/_next/";